module.exports = __webpack_public_path__ + "static/driven-pitch-6f2b4bfd2a453c959ca8e2b338718be5.jpg";